import { render, staticRenderFns } from "./gdyq.vue?vue&type=template&id=10c7c1a8&scoped=true"
import script from "./gdyq.vue?vue&type=script&lang=js"
export * from "./gdyq.vue?vue&type=script&lang=js"
import style0 from "./gdyq.vue?vue&type=style&index=0&id=10c7c1a8&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c7c1a8",
  null
  
)

export default component.exports